export default {"src":"/nachrichten/_next/static/media/Logo.7ce46c07.svg","height":16,"width":45,"blurWidth":0,"blurHeight":0};